import React from 'react';
import './Alert.css';

interface AlertProps {
  type: 'error' | 'warning' | 'success' | 'info';
  children?: React.ReactNode;
  onDismiss?: () => void;
  className?: string;
}

const Alert: React.FC<AlertProps> = ({ type, children, onDismiss, className }) => {
  if (!children) return null;

  return (
    <div className={`alert alert-${type}${className ? ` ${className}` : ''}`} role={type === 'error' || type === 'warning' ? 'alert' : 'status'}>
      <div className="alert-content">{children}</div>
      {onDismiss && (
        <button className="alert-dismiss" onClick={onDismiss} aria-label="Dismiss">
          &times;
        </button>
      )}
    </div>
  );
};

export default Alert;
